jQuery(document).ready(function ($) {
    $('#pass1').parent().addClass('custom_posit_relat');
    $('#pass2').parent().addClass('custom_posit_relat');
})

jQuery(document).ready(function ($) {
    $('.um-field-password .um-field-area').addClass('input_show');
    $('.um-field-password .um-field-area').append('<span class="passwordshow input_eye_gray"></span>')
})

jQuery(document).ready(function ($) {
    $(document).on('click', ".input_show .passwordshow", function () {
        var x = $(this).siblings('input');
        if (x.attr('type') === "password") {
            //console.log(x.attr('type'))
            x.attr('type', "text");
            $(this).removeClass('input_eye_gray');
            $(this).addClass('input_eye_green');
        } else {
            x.attr('type', "password");
            //console.log(x.attr('type'))
            $(this).addClass('input_eye_gray');
            $(this).removeClass('input_eye_green');
        }
    });
})